(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.cart-drawer-upsell__add');
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;

    var variantId = button.getAttribute('data-variant-id');

    button.disabled = true;
    button.classList.add('is-loading');

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-upsell' });
        }
        // The upsell card is removed from the DOM once the drawer refreshes
        // (the mask is now in cart), so the loading animation naturally
        // disappears along with it — no need to explicitly stop it here.
      })
      .catch(function (error) {
        console.error('cart-drawer-upsell add error', error);
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  });
})();
